import { AllSelection, Selection } from 'prosemirror-state';

/**
 * Checks if the given selection is an instance of the `AllSelection` class.
 *
 * @param selection - The selection to check.
 * @returns `true` if the selection is an instance of `AllSelection`, `false` otherwise.
 */
export function isAllSelection(selection: Selection) {
  return selection instanceof AllSelection;
}
